/* eslint-disable no-useless-concat */
import { FETCH_CAR_DONATION } from './types';
import salomapi from '../apis';

export const fetchCarDonation = (code) => async dispatch => {
    const response = await salomapi.get('/spf/cardonation' + `${code ? '?region=' + code : ''}`);
    dispatch({ type: FETCH_CAR_DONATION, payload: response.data })
}
